import React from "react";
import "./Journey.css";
import { Link } from "react-router-dom";

const Journey = () => {
	return (
		<div className='uiowa-journey'>
			<div className='overlay'>
				<div className='content'>
					<div className='inner'>
						<h1>A journey to unity </h1>
						<p>
							Rising to the principles of diversity, equity, and inclusion isn't the
							work of one person or initiative. It's on all Hawkeyes to grow and act
							together, empowering meaningful change.
						</p>
						<Link className='btnUiowa d-flex  gap-3'>
							WATCH UNITY VIDEO
							<span>
								<i
									className='fa fa-arrow-right'
									style={{ color: "#fff" }}
									aria-hidden='true'
								></i>
							</span>
						</Link>
					</div>
				</div>
			</div>
		</div>
	);
};

export default Journey;
